module.exports = __webpack_public_path__ + "static/media/AM1018_lodgement_form_final-page2.c41beeb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/AM1018_lodgement_form_final-page2.jpg
// module id = 1249
// module chunks = 0